export default function ResponsiveTable({ data, headLabels, rowLabel }) {
    return (
        <div className="table-responsive rounded-4">
            <table className="table table-sm table-striped table-light table-hover m-0">
                <thead>
                    <tr>
                        <th className="text-center align-middle" scope="col">
                            {rowLabel}
                        </th>
                        {headLabels.map((label, index) => (
                            <th key={index} className="text-center align-middle" scope="col">
                                {label}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {data.map((row, rowIndex) => (
                        <tr key={rowIndex}>
                            <th className={row.styles ? row.styles : 'text-center align-middle'} scope="row">
                                {row.label}
                            </th>
                            {row.values.map((value, index) => (
                                <td key={index} className={row.valueStyles ? row.valueStyles : 'text-center align-middle'}>
                                    <span className={`px-2 rounded-4 ${parseFloat(value) < 0 && "bg-danger-subtle"}`}>
                                        {headLabels[index] === "Кількість" || headLabels[index] === "К-сть" ? parseFloat(value).toFixed(3) : parseFloat(value).toFixed(2)}
                                    </span>
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}
